import React from 'react'
import { Link } from 'react-router-dom'
import NavigationBar from "carbon-react/lib/components/navigation-bar";
import { Menu, MenuItem } from "carbon-react/lib/components/menu";
import { useSelector } from 'react-redux';
import { ApplicationState } from '../store';

const Navbar = () =>  {
    const userIsAuthenticated = useSelector((state: ApplicationState) => state.authenticationState.authSettings?.isAuthenticated);

  return (
    <React.Fragment>
        { 
            userIsAuthenticated ?
                <NavigationBar navigationType="dark" py={12} px={5}>
                
                    <Menu menuType="dark">
                        <MenuItem>
                            <Link to = "/RequestPage">Upload To MaxOptra</Link>
                        </MenuItem>
                        <MenuItem>              
                            <Link to = "/ExecutePage">Download From MaxOptra</Link>              
                        </MenuItem>
                        <MenuItem>
                            <Link to = "/">Logout</Link>
                        </MenuItem>
                    </Menu>
            
                </NavigationBar>    
            : 
                null}

    </React.Fragment>
    
  )
}; export default Navbar;
